const MesureReactivateStyle = {
  bg: "white",
};

export { MesureReactivateStyle };
